// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.metrics-container {
    align-self: end;
    z-index: 10;
    display: flex;
    margin-top: 5px;
    width: 100%;
    max-width: 100%;
    align-items: start;
    gap: 20px;
    font-family: Inter, sans-serif;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .metric-box {
    border-radius: 5px;
    display: flex;
    align-items: start;
    gap: 5px;
    padding: 6px 9px;
    border: 1px solid rgba(217, 217, 217, 1);
  }
  .metric-icon {
    aspect-ratio: 1;
    object-fit: contain;
    object-position: center;
    width: 21px;
    border-radius: 4px;
  }
  .metric-content {
    display: flex;
    flex-direction: column;
  }
  .metric-value {
    color: rgba(0, 0, 0, 1);
    font-size: 15px;
    text-align: center;
    font-weight: 400;
    z-index: 10;
    background: white;
  }
  .metric-label {
    color: black;
    font-size: 18px;
    font-weight: 500;
    align-self: start;
    background: white;
  }`, "",{"version":3,"sources":["webpack://./src/app/Pages/Machinecard/machinecard.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,eAAe;IACf,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,8BAA8B;IAC9B,eAAe;IACf,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,wCAAwC;EAC1C;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB","sourcesContent":[".metrics-container {\n    align-self: end;\n    z-index: 10;\n    display: flex;\n    margin-top: 5px;\n    width: 100%;\n    max-width: 100%;\n    align-items: start;\n    gap: 20px;\n    font-family: Inter, sans-serif;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n  .metric-box {\n    border-radius: 5px;\n    display: flex;\n    align-items: start;\n    gap: 5px;\n    padding: 6px 9px;\n    border: 1px solid rgba(217, 217, 217, 1);\n  }\n  .metric-icon {\n    aspect-ratio: 1;\n    object-fit: contain;\n    object-position: center;\n    width: 21px;\n    border-radius: 4px;\n  }\n  .metric-content {\n    display: flex;\n    flex-direction: column;\n  }\n  .metric-value {\n    color: rgba(0, 0, 0, 1);\n    font-size: 15px;\n    text-align: center;\n    font-weight: 400;\n    z-index: 10;\n    background: white;\n  }\n  .metric-label {\n    color: black;\n    font-size: 18px;\n    font-weight: 500;\n    align-self: start;\n    background: white;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
